import script from "./InsuranceCancelationDetailsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./InsuranceCancelationDetailsComponent.vue?vue&type=script&setup=true&lang=ts"

import "./InsuranceCancelationDetailsComponent.vue?vue&type=style&index=0&id=20c91752&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20c91752"]])

export default __exports__